import { ApiException } from 'services/ApiService/Http';
import { LogsApi } from 'services/ApiService/ServiceBoard/ServiceBoardApi';
import { ClientLogError, ClientLogFunctional } from 'services/ApiService/ServiceBoard/ServiceBoardApiClient';
import { getSGConnect } from '../sgConnect';
import { toastWarn } from 'components/common/toaster/toast';

interface IValidationError {
    code?: string;
    message?: string;
    target?: string;
    details?: IValidationError[];
}

export interface IError {
    name?: string;
    message: string;
    stack?: string;
}

export let lastError: IError | undefined = undefined;

export const logError = (error: Error | unknown): Promise<void> => {
    if (error instanceof ApiException) {
        switch (error.status) {
            case 401:
                getSGConnect()?.requestAuthorization();
                return Promise.resolve();
            case 400:
                const validationError = error.data as IValidationError;
                if (validationError && validationError.message === 'Validation fails' && validationError.details && validationError.details.length) {
                    const errorDetailsSeparator = '\n\↪ ';
                    toastWarn(validationError.details.map((d) => d.message).join(errorDetailsSeparator));
                    return Promise.resolve();
                }
        }
        return Promise.resolve();
    }

    if (error instanceof Error && error.name !== 'AbortError' && error.message !== 'Failed to fetch') {
        if (lastError?.message !== error.message) {
            lastError = {
                message: error.message,
                name: error.name,
                stack: error.stack,
            };
            const isDocumentDefined = typeof document !== 'undefined';
            const log: ClientLogError = {
                message: error.message,
                name: error.name,
                stackTrace: error.stack,
                pageUrl: isDocumentDefined ? document.location?.pathname : undefined,
            };

            LogsApi.error(log)
                .catch((err) => {
                    throw err;
                });
        }
    }

    return Promise.resolve();
};

export const logFunctional = (feature: string, message: string, parameters?: { [key: string]: number | string | boolean | undefined }): Promise<void> => {
    const ClientLogFunctional: ClientLogFunctional = {
        message: message,
        customParameters: parameters,
        feature: feature,
    };
    LogsApi.functional(ClientLogFunctional).catch((err) => {
        throw err;
    });

    return Promise.resolve();
};
